// const apiServerHost = "1.214.210.85:5001";
let apiServerHost = "http://1.214.210.85:5009";
// const apiServerHost = "";
// const apiServerHost = "http://192.168.10.156:8080"; // kkm
// const apiServerHost = "http://192.168.10.132:8081"; // pse

let imageServerHost = "http://1.214.210.85:5001";

const setApiServerHost = (host) => {
  apiServerHost = host
}
const setImgServerHost = (host) => {
  imageServerHost = host
}

export {apiServerHost, imageServerHost, setApiServerHost, setImgServerHost};